import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { cloneElement } from 'react';
import { PropTypes, describe } from 'react-desc';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import { DSBreadcrumbItem } from './DSBreadcrumbItem.js';

var blockName = 'breadcrumb';

var DSBreadcrumb = function DSBreadcrumb(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'nav' : _ref$as,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Breadcrumb' : _ref$label,
      _ref$isTitle = _ref.isTitle,
      isTitle = _ref$isTitle === void 0 ? false : _ref$isTitle,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["containerProps", "as", "label", "isTitle", "children"]);

  var SafeComponent = ['nav', 'div', 'header', 'footer', 'main'].indexOf(Component) > -1 ? Component : 'nav';
  var NavContainer = aggregatedClasses(SafeComponent)(blockName);
  return /*#__PURE__*/React.createElement(NavContainer, _extends({
    "aria-label": label,
    "data-testid": "breadcrumb-nav-container"
  }, rest, containerProps), /*#__PURE__*/React.createElement("ol", {
    "data-testid": "list-container"
  }, React.Children.map(children, function (child, i) {
    return i < children.length - 1 ? child : /*#__PURE__*/cloneElement(child, {
      active: true,
      isTitle: isTitle
    });
  })));
};

DSBreadcrumb.Item = DSBreadcrumbItem;
var props = {
  /** props injected to breadcrumb wrapper */
  containerProps: PropTypes.object.description('props injected to breadcrumb wrapper'),

  /**
   * Type of element you want the main container to be:
   * 'nav', 'div', 'header', 'footer', 'main'
   */
  as: PropTypes.string.description("Type of element you want the main container to be: 'nav', 'div', 'header', 'footer', 'main'"),

  /**
   * Whether to show the last element of the breadcrumb as a title
   * Also removes trailing slash to show last element as title
   */
  isTitle: PropTypes.bool.description('Whether to show the last element of the breadcrumb as a title. Also removes trailing slash to show last element as title'),

  /** breadcrumb label */
  label: PropTypes.string.description('breadcrumb label'),

  /**
   * Container items to wrap
   */
  children: PropTypes.arrayOf(DSBreadcrumbItem).isRequired.description('Container items to wrap')
};
DSBreadcrumb.propTypes = props;
var DSBreadcrumbWithSchema = describe(DSBreadcrumb);
DSBreadcrumbWithSchema.propTypes = props;

export default DSBreadcrumb;
export { DSBreadcrumb, DSBreadcrumbWithSchema };
//# sourceMappingURL=DSBreadcrumb.js.map
